import React, { useState, useRef } from 'react';
import { DateUtils } from 'react-day-picker';
import { makeStyles } from '@material-ui/styles';
import {
    Typography,
    TextField,
    MenuItem,
    Popper,
    Fade,
    Paper,
    ClickAwayListener,
} from '@material-ui/core';
import { getDateStrJSON } from 'utils/date-utils';
import { DatePicker } from './DatePicker';

const useStyles = makeStyles(theme => ({
    popper: {
        zIndex: 1500,
    },
    textField: {
        color: '#212121 !important',
        cursor: 'pointer',

        '&:defore': {
            borderBottomStyle: 'initial',
        },
    },
    fieldLabel: {
        lineHeight: '32px',
        marginRight: theme.spacing(),
    },
}));

const getReadableRange = (from, to) => {
    if (!from || !to) {
        return 'not selected';
    }

    const parsedTo = getDateStrJSON(to);
    const strTo = `${parsedTo.month} ${parsedTo.day}, ${parsedTo.year}`;
    if (DateUtils.isSameDay(from, to)) {
        return strTo;
    }

    const { month, year, day } = getDateStrJSON(from);
    const strFrom =
        `${month} ${day}` +
        (!year.startsWith(parsedTo.year) ? `, ${year}` : '');

    return `${strFrom} - ${strTo}`;
};

const getInputLabel = data => {
    if (data && data.selectedType) {
        return data.selectedType.title;
    }

    return 'Date range';
};

const DatePickerInput = ({ range, onDateChange }) => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [dateData, setDateData] = useState(range);
    const anchorRef = useRef(null);

    function handleClick(event) {
        event.preventDefault();
        event.stopPropagation();
        setOpen(prevOpen => !prevOpen);
    }

    const handleClose = () => setOpen(false);

    const selectedDate = dates => {
        setDateData(dates);
        setOpen(false);
        onDateChange(dates);
    };

    return (
        <div>
            <Typography
                className={classes.fieldLabel}
                variant="subtitle2"
                component="span"
            >
                {getInputLabel(dateData)}
            </Typography>
            <TextField
                select
                value="1"
                disabled
                ref={anchorRef}
                InputProps={{
                    className: classes.textField,
                }}
                onClick={handleClick}
            >
                <MenuItem value="1">
                    {getReadableRange(dateData.from, dateData.to)}
                </MenuItem>
            </TextField>
            <Popper
                className={classes.popper}
                open={open}
                anchorEl={anchorRef.current}
                keepMounted={true}
                transition
                placement="bottom-start"
                style={{ position: 'initial' }}
            >
                {({ TransitionProps }) => (
                    <Fade {...TransitionProps} timeout={350}>
                        <Paper elevation={5}>
                            <ClickAwayListener onClickAway={handleClose}>
                                <DatePicker
                                    onDateSelected={selectedDate}
                                    initial={dateData}
                                />
                            </ClickAwayListener>
                        </Paper>
                    </Fade>
                )}
            </Popper>
        </div>
    );
};

export { DatePickerInput };
